export default {
    id: null,
    matricula: null,
    transcricao: null,
    cri: null,
    comarca: null,
    processo: null,
    dataPedido: null,
    dataEntrega: null,
    valor: null,
    status: 0,
    active: true,
}
